export const MAX_IMAGE_BYTES = 20 * 1024 * 1024;
const TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/avif'];

export function imageFileError(file) {
  if (!file || !file.size) return 'El archivo está vacío. Elegí otra foto.';
  if (file.size > MAX_IMAGE_BYTES) return `La foto pesa ${(file.size / 1024 / 1024).toFixed(1)} MB. El máximo es 20 MB.`;
  // Algunos dispositivos no informan MIME. El servidor siempre verifica los bytes.
  if (!TYPES.includes(file.type) && !(!file.type && /\.(jpe?g|png|webp|gif|avif)$/i.test(file.name))) {
    return 'Formato no admitido. Usá JPG, PNG, WebP, GIF o AVIF; convertí HEIC/HEIF antes de subir.';
  }
  return '';
}
